import { render, staticRenderFns } from "./WebSiteCourseFormModal.vue?vue&type=template&id=0a4bcaeb&scoped=true"
import script from "./WebSiteCourseFormModal.vue?vue&type=script&lang=js"
export * from "./WebSiteCourseFormModal.vue?vue&type=script&lang=js"
import style0 from "./WebSiteCourseFormModal.vue?vue&type=style&index=0&id=0a4bcaeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bcaeb",
  null
  
)

export default component.exports